"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ko = __importStar(require("knockout"));
const CalendarViewModel_1 = __importDefault(require("./model/view-model/CalendarViewModel"));
const CalendarWeekModelBuilder_1 = __importDefault(require("./utility/CalendarWeekModelBuilder"));
const CalendarConfiguration_1 = __importDefault(require("./model/configuration/CalendarConfiguration"));
const CalendarEventResultModelFactory_1 = __importDefault(require("./events/factory/CalendarEventResultModelFactory"));
const CalendarEvents_1 = __importDefault(require("./events/CalendarEvents"));
const initialState = () => {
    return Object.assign({}, {
        initialized: false,
        view: {
            isKOInit: false,
            container: undefined,
            viewModel: {
                calendar: undefined
            }
        },
        stringsProvider: undefined
    });
};
/**
 * This class is responsible for initializing the view model and binding the view component to model.
 */
class CommonCalendarWidget {
    constructor(calWidgetId, stringsProvider) {
        this.state = initialState();
        this.eventResultModels = new CalendarEventResultModelFactory_1.default().getEventResultModels();
        this.state.view.container = document.querySelector('#' + calWidgetId);
        this.state.stringsProvider = stringsProvider;
        this.eventsName = this.getCalendarEventsName(calWidgetId);
        this.events = new CalendarEvents_1.default(calWidgetId, this.eventsName);
    }
    loadCalendar(calendarModel, selectedSlotIds, calendarModelKey) {
        let updatedCalendarModel;
        const configuration = new CalendarConfiguration_1.default(calendarModel.configuration);
        if (!calendarModel.weeks) {
            updatedCalendarModel = new CalendarWeekModelBuilder_1.default().build(calendarModel);
        }
        else {
            updatedCalendarModel = calendarModel;
        }
        if (this.state.initialized === true) {
            this.reloadCalendar(updatedCalendarModel, selectedSlotIds, calendarModelKey);
        }
        else {
            this.init(updatedCalendarModel, configuration, selectedSlotIds, calendarModelKey);
        }
    }
    selectSlot(slotId) {
        this.state.view.viewModel.calendar.calendarEvents.selectSlot(slotId);
    }
    deselectSlot(slotId) {
        this.state.view.viewModel.calendar.calendarEvents.deselectSlot(slotId);
    }
    selectDate(dateId) {
        this.state.view.viewModel.calendar.calendarEvents.selectDate(dateId);
    }
    isMaxSelectionCompleted() {
        const selectedSlotIndexes = this.state.view.viewModel.calendar.selectedSlotIndexes();
        return (selectedSlotIndexes.length === this.state.view.viewModel.calendar.configuration.numOfSelection) ? true : false;
    }
    getSlotIdOfPreferences() {
        const slotIndexOfPreferences = this.state.view.viewModel.calendar.slotIndexOfPreferences();
        const slotIdOfPreferences = slotIndexOfPreferences.filter((slotIndex) => {
            return slotIndex != undefined || slotIndex !== null
                ? (this.state.view.viewModel.calendar.slots()[slotIndex]).slotId
                : null;
        });
        return slotIdOfPreferences;
    }
    init(calendarModel, configuration, selectedSlotIds, calendarModelId) {
        try {
            const calendarViewModel = new CalendarViewModel_1.default(this.state.stringsProvider, calendarModel, configuration, selectedSlotIds, this.events, calendarModelId);
            this.state.view.viewModel.calendar = calendarViewModel;
            this.initKnockout();
            this.state.initialized = true;
            if (selectedSlotIds.length > 0) {
                calendarViewModel.retriggerSelectedSlotEvents();
            }
            this.dispatchCalendarLoadEvents(calendarModel, this.eventsName.calReloaded, false);
        }
        catch (error) {
            this.dispatchCalendarLoadEvents(calendarModel, this.eventsName.calReloaded, true);
            console.log(error);
            throw error;
        }
    }
    initKnockout() {
        if (this.state.view.isKOInit === undefined || this.state.view.isKOInit === false) {
            ko.applyBindings(this.state.view.viewModel, this.state.view.container);
            this.state.view.isKOInit = true;
        }
    }
    dispatchCalendarLoadEvents(calendarSourceData, eventName, hasError) {
        const calEventResult = this.eventResultModels.CalReloaded();
        calEventResult.isEmptyCalendar = (calendarSourceData.days.length > 0 ? false : true);
        calEventResult.hasError = hasError;
        this.state.view.container.dispatchEvent(new CustomEvent(eventName, {
            detail: calEventResult
        }));
    }
    reloadCalendar(calendarModel, selectedSlotIds, calendarModelId) {
        try {
            this.state.view.viewModel.calendar.loadCalendar(calendarModel, selectedSlotIds, calendarModelId);
            this.dispatchCalendarLoadEvents(calendarModel, this.eventsName.calRedraw, false);
        }
        catch (error) {
            this.dispatchCalendarLoadEvents(calendarModel, this.eventsName.calRedraw, true);
            console.log(error);
            throw error;
        }
    }
    getCalendarEventsName(calWidgetId) {
        return {
            calReloading: 'calreling:' + calWidgetId,
            calReloaded: 'calrel:' + calWidgetId,
            calRedraw: 'calredraw:' + calWidgetId,
            daySelected: 'datesel:' + calWidgetId,
            slotSelected: 'slotsel:' + calWidgetId,
            slotDeselected: 'slotdesel:' + calWidgetId,
            nextDaysClicked: 'nextdatesclick:' + calWidgetId,
            prevDaysClicked: 'prevdatesclick:' + calWidgetId
        };
    }
}
exports.default = CommonCalendarWidget;
